import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { VerifyCodeComponent } from '../../pages/verify-code/verify-code.component';

@Injectable({
  providedIn: 'root'
})
export class PreventBackToLoginGuard implements CanDeactivate<VerifyCodeComponent> {

  canDeactivate(
    _component: VerifyCodeComponent,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // Rutas pre-autenticación a las que NO se puede regresar desde verify-code
    const blockedRoutes = ['/login', '/authentication', '/create-new-password'];
    if (nextState) {
      const isBlocked = blockedRoutes.some(route => nextState.url.includes(route));
      if (isBlocked) {
        return false;
      }
    }
    return true;
  }
}
